var angular = require('angular');
var _module = require('../module');

require('../window-height');

_module.controller('HeroCtrl', [
    '$log',
    '$window',
    '$element',

    function HeroCtrl($log, $window, $element) {
        $log.debug('HeroCtrl', this);

        var vm = this;

        // Lifecycle Hooks
        vm.$onChanges = onBindingsChange;

        // Functions
        function onBindingsChange(bindings) {
            updateBackgroundImage(bindings.image.currentValue, bindings.image.previousValue);
        }

        function updateBackgroundImage(newValue, oldValue) {
            if(newValue !== oldValue && newValue) {
                $element.css('backgroundImage', ["url('", newValue, "')"].join(''));
            }
        }
    }
]);

_module.component('hero', {
    controllerAs: 'vm',
    controller: 'HeroCtrl',
    template: require('./index.html'),
    bindings: {
        image: '@',
        contentLayout: '@',
        contentAlign: '@'
    },
    transclude: true
});
